//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { JusticeOfThePeaceLargeSVG } from './svg'

interface JusticeOfThePeaceLargeIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const JusticeOfThePeaceLargeIcon: React.FC<JusticeOfThePeaceLargeIconProps> = forwardRef<
  JusticeOfThePeaceLargeIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={JusticeOfThePeaceLargeSVG}
    sx={sx}
  />
))
